// extracted by mini-css-extract-plugin
module.exports = {"hideXOverflow":"PageSection_hideXOverflow__69uwq","container":"PageSection_container__Z4bO4","dividerPadding":"PageSection_dividerPadding__O9Ctw"};